import { useEffect } from "react";
import * as Yup from "yup";
import { useFormik, Form, FormikProvider } from "formik";
import styled from "@emotion/styled";
import {
  FormControlLabel,
  Button,
  TextField as MuiTextField,
  Switch,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { spacing } from "@mui/system";
import useNotification from "hooks/useNotification";
import useReferentiel from "hooks/useReferentiel";
import useGift from "hooks/useGift";
// ----------------------------------------------------------------------
const TextField = styled(MuiTextField)(spacing);
export default function GiftActivatedForm({ editData, onComplete }) {
  const { saveGiftActivated, getGiftsActivated } = useGift();
  const { notif } = useNotification();
  const { refs } = useReferentiel();

  const dataSchema = Yup.object().shape({
    userCodeGift: Yup.string().max(255).required("Veuillez renseigner le code"),
    executedat: Yup.date().required(`Veuillez renseigner la date d'activation`),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userCodeGift: editData ? editData.userCodeGift : "",
      executedat: editData ? editData.executedat : "",
      enable: editData ? editData.enable : false,
    },
    validationSchema: dataSchema,
    onSubmit: async () => {
      try {
        const newData = { ...editData, ...values };
        await saveGiftActivated(newData);
        await getGiftsActivated();
        notif("Sauvegarde réussie");
        onComplete();
      } catch (error) {
        console.error(error);
        notif(null, error);
        setSubmitting(false);
      }
    },
  });

  const {
    errors,
    touched,
    values,
    isSubmitting,
    handleSubmit,
    getFieldProps,
    setSubmitting,
    handleChange,
    setFieldValue,
  } = formik;
  useEffect(() => {
    if (!setFieldValue) return;
    if (editData && editData.enabledat) {
      setFieldValue("enabledat", editData.enabledat);
    } else {
      setFieldValue("enabledat", new Date());
    }
  }, [setFieldValue, editData]);

  return (
    <>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <TextField
            fullWidth
            type="text"
            name="userCodeGift"
            label="Code d'activation"
            {...getFieldProps("userCodeGift")}
            error={Boolean(touched.userCodeGift && errors.userCodeGift)}
            helperText={touched.userCodeGift && errors.userCodeGift}
            my={2}
          />
          <DatePicker
            inputFormat="dd/MM/yyyy"
            onChange={(value) => {
              setFieldValue("executedat", value, true);
            }}
            value={values.executedat}
            renderInput={(params) => (
              <TextField
                fullWidth
                label="Date d'activation"
                {...getFieldProps("executedat")}
                error={Boolean(touched.executedat && errors.executedat)}
                helperText={touched.executedat && errors.executedat}
                my={2}
                {...params}
              />
            )}
          />
          {/* add switch component value is enable */}
          <FormControlLabel
            control={
              <Switch
                name="enable"
                checked={values.enable}
                onChange={(e) => setFieldValue("enable", e.target.checked)}
              />
            }
            label="Activé"
          />
          <Button
            sx={{ my: 2 }}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            Valider
          </Button>
        </Form>
      </FormikProvider>
    </>
  );
}
